<template>
  <div class="contact container">
    <h1>
      Contact
    </h1>
    <div
      v-if="success"
      class="success tile notification is-success">
      {{ $t('Contact.SendSuccess') }}
    </div>
    <form
      v-else
      onsubmit="return false">
      <div class="field">
        <label class="label">{{ $t('Contact.Name') }}</label>
        <div class="control">
          <input
            :placeholder="$t('Contact.Name')"
            v-model="formData.fromName"
            class="input"
            type="text"
            name="from-name"
            required>
          <span
            v-if="formData.fromNameError !== ''"
            class="form-error">{{ formData.fromNameError }}</span>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t('Contact.Email') }}</label>
        <div class="control">
          <input
            :placeholder="$t('Contact.Email')"
            v-model="formData.fromEmail"
            class="input"
            type="email"
            name="from-rmail"
            required>
          <span
            v-if="formData.fromEmailError !== ''"
            class="form-error">{{ formData.fromEmailError }}</span>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t('Contact.Message') }}</label>
        <div class="control">
          <textarea
            :placeholder="$t('Contact.Message')"
            v-model="formData.message"
            name="message"
            class="textarea"
            required />
        </div>
      </div>

      <div class="full-width">
        <button
          class="send-contact navigation secondary"
          @click="submitEmailForm">{{ $t('Contact.Send') }}</button>
      </div>
    </form>
    <div class="columns footer">
      <div class="column footercolumn">
        <p>Vanhoutte Trading bvba</p>
        <p>Ambachtenlaan 24</p>
        <p>BE-8760 Meulebeke</p>
      </div>
      <div class="column footercolumn">
        <p>GSM +32 475 274507</p>
        <p>FAX +32 51 484430</p>
        <p>jean-philip.vanhoutte@telenet.be</p>
      </div>
      <div class="column footercolumn">
        <p>BE 0715.660.159</p>
        <p>RPR Kortrijk</p>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import config from "@/config";

export default {
  name: "Header",
  data() {
    return {
      formData: {
        fromName: "",
        fromNameError: "",
        fromEmail: "",
        fromEmailError: "",
        message: "",
        messageError: ""
      },
      success: false
    };
  },
  methods: {
    submitEmailForm() {
      const data = this.formData;
      axios.post(`${config.API_ROOT}/contact`, data)
        .then(() => {
          this.clearFields();
        });
    },
    clearFields() {
      this.formData.fromName = "";
      this.formData.fromEmail = "";
      this.formData.message = "";
      this.success = true;
    }
  }
};

</script>

<style scoped lang="scss">
@import "@/assets/css/style.scss";

.contact {
  margin-top: 40px;
  margin-bottom: 80px;
}

.send-contact {
  background-color: #e0493e;
  text-align: center;
  padding: 20px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 16px;
  cursor: pointer
}

h1 {
  color: $secundary;
  font-size: 32px;
  margin-top: 10px;
  margin-bottom: 40px;
}

.success {
  margin-top: 20px;
  font-weight: bold;
}

.footer {
  margin: 40px 0px 0px;
  padding: 0px;
  border: 1px solid $primary;
}
.footercolumn {
  text-align: center;
  margin: 20px, 0px;
}

@media (max-width: 1087px) {
  .contact {
    margin: 40px 20px 80px;
  }
}

</style>
